// extracted by mini-css-extract-plugin
module.exports = {"YXHSignContract":"index-module_YXHSignContract_2QDAl","title":"index-module_title_1R91O","idCard":"index-module_idCard_2ekyb"};